module.exports = __webpack_public_path__ + "4819df6ba22b00c661a7860c32d8a496.wav";